
import {
  computed, defineComponent, PropType, ref,
} from 'vue'
import { Message } from '@/types/webinar.d'
import IconTrash from '@/vue/icons/IconTrash.vue'
import IconUserSlash from '@/vue/icons/IconUserSlash.vue'
import axios from 'axios'
import { useStore } from '@/vue/store'
import { useI18n } from 'vue-i18n'
import IconCheck from '@/vue/icons/IconCheck.vue'

export default defineComponent({
  name: 'ChatMessage',
  props: {
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
    archived: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IconCheck,
    IconTrash,
    IconUserSlash,
  },
  emits: ['deleted'],
  setup(props, { emit }) {
    const { t } = useI18n()
    const store = useStore()

    const loading = ref(false)

    return {
      t,

      currentUserAdmin: computed(() => store.state.userAdmin && !props.archived),
      text: computed(() => props.message.message
        .replace(/[&<>]/g, (e) => {
          if (e === '&') {
            return '&amp;'
          }
          return e === '<' ? '&lt;' : '&gt;'
        })
        .replace(/((http|https|ftp):\/\/[\w?=&./-;#~%-]+(?![\w\s?&./;#~%"=-]*>))/g, '<a href="$1" target="_blank">$1</a>')),

      time: computed(() => {
        const hours = props.message.timestamp.getHours()
        const minutes = props.message.timestamp.getMinutes()
        const seconds = props.message.timestamp.getSeconds()
        return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
      }),

      async deleteMessage() {
        if (store.state.userAdmin) {
          let { message } = props.message
          if (message.length > 50) {
            message = `${message.substr(0, 47)}...`
          }
          // eslint-disable-next-line no-alert
          if (confirm(t('public.confirmRemoving', {
            user: props.message.userName,
            message,
          }))) {
            loading.value = true
            await axios.delete(`/messages/${props.message.id}`)
            emit('deleted')
          }
        }
      },
      async banUser() {
        // eslint-disable-next-line no-alert
        if (store.state.userAdmin && confirm(t('public.confirmRemoving', {
          user: props.message.userName,
        }))) {
          loading.value = true
          await axios.put(`/users/${props.message.userId}/ban`)
          emit('deleted')
        }
      },
      async approveMessage() {
        if (store.state.userAdmin) {
          let { message } = props.message
          if (message.length > 50) {
            message = `${message.substr(0, 47)}...`
          }
          // eslint-disable-next-line no-alert
          if (confirm(t('public.confirmApproving', {
            user: props.message.userName,
            message,
          }))) {
            loading.value = true
            const { data } = await axios.post(`/messages/${props.message.id}/approve`)
            if (data.success) {
              emit('deleted')
            }
          }
        }
      },
    }
  },
})
